import { Classes } from 'jss';
import { createUseStyles } from 'react-jss';
import { ActionPalette } from '@tcl-boron-colors/colors';

export const useScrollbarStyles: () => Classes<'scrollbar'> = createUseStyles({
  scrollbar: {
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${ActionPalette[400]} transparent`,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '16px',
      background: ActionPalette[400],
      border: '6px solid rgba(0, 0, 0, 0)',
      backgroundClip: 'padding-box',
    },
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '16px',
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none',
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },
  },
});
